<div class="cancel-booking" *ngIf="bookingsTexts">

    <serviceos-ng-form
        *ngIf="!formCompleted else successScreen"
        [choices]="cancelForm.choices"
        (onAction)="onFormAction($event)"
        [errorMessage]="formErrorMessage"
        [showLoader]="showFormLoader">
    </serviceos-ng-form>
</div>

<ng-template #successScreen>
    <div *ngIf="successMessage" class="success-page-holder">
        <div class="message-holder">
            <div class="title">
                <h3>{{ texts['cancel_success_screen_title'] ? texts['cancel_success_screen_title'] : 'Thank you for your submission' }}</h3>
            </div>
            <!-- <div class="description">
                <p>{{ successMessage }}</p>
            </div> -->
        </div>
        <div class="buttons-holder">
            <serviceos-ng-button (click)="onSuccessScreenConfirmation()" [isFullWidth]="true">{{ texts['cancel_success_screen_button_label'] ? texts['cancel_success_screen_button_label'] : 'Done' }}</serviceos-ng-button>
        </div>
    </div>
</ng-template>